/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Quick_Slug_AriseInputs */

const es_zippy_quick_slug_arise = /** @type {(inputs: Zippy_Quick_Slug_AriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección de email`)
};

const gl_zippy_quick_slug_arise = /** @type {(inputs: Zippy_Quick_Slug_AriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enderezo de correo electrónico`)
};

const en_zippy_quick_slug_arise = /** @type {(inputs: Zippy_Quick_Slug_AriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Zippy_Quick_Slug_AriseInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const zippy_quick_slug_arise = /** @type {((inputs?: Zippy_Quick_Slug_AriseInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Quick_Slug_AriseInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_zippy_quick_slug_arise(inputs)
	if (locale === "en") return en_zippy_quick_slug_arise(inputs)
	return es_zippy_quick_slug_arise(inputs)
});